import { render, staticRenderFns } from "./AreaAdd.vue?vue&type=template&id=323457df&scoped=true"
import script from "./AreaAdd.vue?vue&type=script&lang=js"
export * from "./AreaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323457df",
  null
  
)

export default component.exports